exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-styles-pages-___terms-conditions__mainText___LFeF2{padding-top:20px;color:#b18433;text-align:center;font-family:Lato,Open Sans,serif}.src-components-styles-pages-___terms-conditions__privacyBackround___kp9db{background-color:#fff;padding:30px 100px;margin:20px 0;box-shadow:0 1px 1px 0 rgba(0,0,0,.2)}@media (max-width:991px){.src-components-styles-pages-___terms-conditions__privacyBackround___kp9db{padding:30px}}.src-components-styles-pages-___terms-conditions__privacyBackround___kp9db p{text-align:justify;padding-bottom:10px}.src-components-styles-pages-___terms-conditions__privacyBackround___kp9db a{color:#b18433!important}.src-components-styles-pages-___terms-conditions__privacyBackround___kp9db a:active,.src-components-styles-pages-___terms-conditions__privacyBackround___kp9db a:focus,.src-components-styles-pages-___terms-conditions__privacyBackround___kp9db a:hover{color:#9e937e!important}.src-components-styles-pages-___terms-conditions__subtitle___36G7C{color:#b18433}", ""]);

// exports
exports.locals = {
	"mainText": "src-components-styles-pages-___terms-conditions__mainText___LFeF2",
	"privacyBackround": "src-components-styles-pages-___terms-conditions__privacyBackround___kp9db",
	"subtitle": "src-components-styles-pages-___terms-conditions__subtitle___36G7C"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/sass-loader!./src/components/styles/pages/terms-conditions.scss
 ** module id = 928
 ** module chunks = 0
 **/